'use client';

import { Suspense } from 'react';
import { LandingLogin } from '@/components/auth/LandingLogin';

function LoadingFallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <LandingLogin />
    </Suspense>
  );
}
